export default __webpack_public_path__ + "static/media/914.23a72ee0.png";